import React from 'react';
import { Box } from '@wix/design-system';
import { SpacingControl } from './SpacingControl';
import {
  GAP_CSS_PROPERTY_TYPES,
  PADDING_CSS_PROPERTY_TYPES,
} from '../../common/constants';

export const SpacingControls: React.FC = () => {
  // TODO add translations
  return (
    <Box direction="vertical">
      <SpacingControl
        cssPropertyTypes={PADDING_CSS_PROPERTY_TYPES}
        label="Padding"
      />
      <SpacingControl
        cssPropertyTypes={GAP_CSS_PROPERTY_TYPES}
        label="Spacing"
      />
    </Box>
  );
};
